export const isEmpty = (val) => {
    return val === null || val === undefined || val === "";
}
